import moment from "moment";
import Common from './Common';
import { DbCourseManagement } from "../database/DbCourseManagement";
import { DbHistoryManagement, DbHistoryManagementDetail } from '../database/DbHistoryManagement'

import CsvParse from 'csv-parse';

/** 
 項目
・分科会がない講習：「申込番号」「出席」
・分科会がある講習：「申込番号」「出席」 「講義・分科会等1（{名称}）：出席」「講義・分科会等2（{名称}）：出席」…

1行目は見出しを出力（括弧、コロンは全角）
2行目以降に値を出力
　申込番号 → 受講登録時の申込番号
　出席 → 分科会がない：講習を「受講完了」 （=すべての章を受講完了）のとき”○”、それ以外のときは空白
　　　　  分科会がある：一つ以上の分科会を「受講完了」 （=分科会のすべての章を受講完了）したとき”○”、どれも完了していないときは空白
　講義・分科会等N （{名称}）：出席 → 「受講完了」のとき（=その分科会のすべての章を受講完了）”○”、それ以外のときは空白
　
ファイル名：{講習ID}_{講習名}_受講履歴_{年月日時分秒(年は4桁、他は2桁）}.csv
文字コードはUTF-8, 改行コードはCRLF
 */
class CsvRow {
    applicationNumber: number | null;
    subcommitteeNumber: string | null;
    status: string;
    constructor(applicationNumber: number,
        subcommitteeNumber: string,
        status: string){
            this.applicationNumber = applicationNumber;
            this.subcommitteeNumber = subcommitteeNumber;
            this.status = status;
    }
}

class DownloadCsv {
    private static courseManagement?: DbCourseManagement;
    private static rows: DbHistoryManagement[];
    private static detailRows: DbHistoryManagementDetail[];

    // CSV生成 と ダウンロード処理
    public static downloadCsv(csvLink: any, courseManagement: DbCourseManagement, rows: DbHistoryManagement[], detailRows: DbHistoryManagementDetail[]) {
        this.courseManagement = courseManagement;
        this.rows = this.sortRows( rows );
        this.detailRows = this.sortDetailRows( detailRows );

        // ファイル名 {講習ID}_{講習名}_受講履歴_{年月日時分秒(年は4桁、他は2桁）}.csv
        csvLink.download = this.createCsvFileName();

        // CSVヘッダー作成
        let csvRows = this.createHeaderRow();
        // CSVデータ作成
        csvRows += this.createDataRow();
        Common.downloadCsv(csvRows, csvLink);
    }

    // ファイル名 {講習ID}_{講習名}_受講履歴_{年月日時分秒(年は4桁、他は2桁）}.csv
    private static createCsvFileName(): string {
        const courseId = this.courseManagement!.courseId;
        const name = this.courseManagement!.name;
        // 2021.03.05 「時」を24h表記（HH）に修正
        const from = moment().format('YYYYMMDDHHmmss');
        return `${courseId}_${name}_受講履歴_${from}.csv`;
    }

    // ヘッダー行を生成
    //  項目
    // ・分科会がない講習：「申込番号」「出席」
    // ・分科会がある講習：「申込番号」「出席」 「講義・分科会等1（{名称}）：出席」「講義・分科会等2（{名称}）：出席」…
    private static createHeaderRow(): string {
        let rows = "申込番号,出席";
        // subcommitteeNumber 分科会 番号 確認
        const lecturesSubcommittees = this.rows[0].lecturesSubcommittees;
        if (lecturesSubcommittees.length != 0){
            // 分科会あり
            lecturesSubcommittees.forEach((lecturesSubcommittee) => {
                // 講義・分科会等N（{名称}）：出席
                const title = lecturesSubcommittee.replace('申込', '出席');
                rows += `,${title}`;
            });
        }
        rows += "\r\n";
        return rows;
    }

    // 講習ID順にソートする
    private static sortRows(rows: DbHistoryManagement[]): DbHistoryManagement[]{
        return rows.sort((a,b) => {
            // 講習ID
            if(a.courseManagementId > b.courseManagementId){
                return 1;
            }
            else if(a.courseManagementId < b.courseManagementId){
                return -1;
            }
            return 0;
        });
    }

    // 申し込み番号順にソートする
    private static sortDetailRows(rows: DbHistoryManagementDetail[]): DbHistoryManagementDetail[]{
        return rows.sort((a,b) => {
          // 申込番号
          if(a.applicationNumber > b.applicationNumber){
            return 1;
          }
          else if(a.applicationNumber < b.applicationNumber){
            return -1;
          }
          return 0;
        });
    }

    // データ行
    private static createDataRow(): string {
        let rows = "";
        // subcommitteeNumber 分科会 番号 確認
        const lecturesSubcommittees = this.rows[0].lecturesSubcommittees;
        if (lecturesSubcommittees.length == 0){
            // 分科会 なし
            this.rows.forEach((row) => {
                const done = (row.status === DbHistoryManagement.STATUS.Done) ? '○': '';
                rows += `${row.applicationNumber},${done}\r\n`;
            });
        } else {
            // 申込番号
            const applicationNumbers: number[] = [];
            // 出席出力
            this.rows.forEach((row) => {
                applicationNumbers.push(row.applicationNumber);
            });
            // 申込番号-出席列の値
            const attendStatus: { [key: number]: string } = {};
            
            const csvRows: CsvRow[] = [];
            // 申込番号 毎にフィルター
            applicationNumbers.forEach((applicationNumber) => {
                const historyManagementDetails = this.detailRows.filter((r) => {
                    if (r.applicationNumber == applicationNumber) return true;
                    return false;
                });
                console.log(`${applicationNumber} Details`, historyManagementDetails);
                // 分科会毎に 状態 確認
                let finishedSubommitteeCount = 0; // 受講完了した分科会数
                let subcommitteeNumber = "";
                let donCnt = 0;
                let rowCnt = 0;
                historyManagementDetails.forEach((detail) => {
                    if (subcommitteeNumber !== detail.subcommitteeNumber) {
                        if (subcommitteeNumber !== ""){
                            const status = (donCnt == rowCnt) ? '○' : '';
                            console.log(`sub ${subcommitteeNumber} ${status}`);
                            csvRows.push( new CsvRow(applicationNumber, subcommitteeNumber, status) );
                            if (donCnt == rowCnt)
                            {
                                finishedSubommitteeCount++;
                            }
                        }
                        subcommitteeNumber = detail.subcommitteeNumber;
                        donCnt = 0;
                        if (detail.status == DbHistoryManagementDetail.STATUS.Done) {
                            donCnt = 1;
                        }
                        rowCnt = 1;
                    } else {
                        if (detail.status == DbHistoryManagementDetail.STATUS.Done) {
                            donCnt++;
                        }
                        rowCnt++;
                    }
                });
                if (subcommitteeNumber !== ""){
                    const status = (donCnt == rowCnt) ? '○' : '';
                    console.log(`sub ${subcommitteeNumber} ${status}`);
                    csvRows.push( new CsvRow(applicationNumber, subcommitteeNumber, status) );
                    if (donCnt == rowCnt)
                    {
                        finishedSubommitteeCount++;
                    }
                }

                // 分科会を1個以上受講完了している場合、出席="○"とする
                attendStatus[applicationNumber] = (finishedSubommitteeCount > 0) ? '○' : '';
            });

            // 出席出力
            this.rows.forEach((row) => {
                const done = attendStatus[row.applicationNumber];
                // 申込番号,出席
                rows += `${row.applicationNumber},${done}`;
                csvRows.filter((r) => {
                    if (r.applicationNumber == row.applicationNumber) return true;
                    return false;
                }).forEach((r) => {
                    console.log('r', r);
                    rows += `,${r.status}`;
                });
                rows += '\r\n';
            });
        }
        return rows.trim() + '\r\n';
    }
}

export default DownloadCsv;